import { Pipe, PipeTransform } from '@angular/core';
import { InstallationDistancePluginService } from './distance.service';
@Pipe({
    name: 'distance',
    standalone: false
})
export class InstallationDistancePipe implements PipeTransform {
  public distances: any[];
  constructor(private service: InstallationDistancePluginService) {
    this.distances = this.service.getDistances();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.distances);
  }
}
